// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgNotHomeIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="m8.72 5.87 2.58-2.58c.2-.2.45-.29.71-.29s.51.1.71.29l8 8c.29.29.37.72.22 1.09s-.52.62-.92.62h-1v3.15zM19 19.02v-.04L7.3 7.28l-.02.02-1.57-1.57A.996.996 0 1 0 4.3 7.14l1.57 1.57-2.58 2.58c-.29.29-.37.72-.22 1.09s.52.62.92.62h1v7c0 .55.45 1 1 1h12s.08-.02.13-.03l.73.73c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41z" />
  </g>
);
export default SvgNotHomeIcon;
SvgNotHomeIcon.displayName = 'SvgNotHomeIcon';
